import { Menu, menuTag } from '@ni/nimble-components/dist/esm/menu';
import { wrap, type EventName } from '../utilities/react-wrapper';
import type { MenuItemChangeEvent } from '../menu-item';

export { menuTag };
export { type Menu };
export const NimbleMenu = wrap(Menu, {
    events: {
        onChange: 'change' as EventName<MenuChangeEvent>,
    }
});
/**
 * Bubbling event emitted by a menu item child when selected.
 * Easier to listen for the event on parent menu than on each menu item child.
 */
export type MenuChangeEvent = MenuItemChangeEvent;
